new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: ''
    },
    methods: {
    // Máscara/validação do formulário "avise-me quando chegar".
    // Os eventos são delegados no document porque o formulário só é injetado
    // quando o cliente escolhe uma variação sem estoque, e é re-renderizado a
    // cada troca de tamanho: listeners presos no elemento se perderiam.
    initNotifyNotAvailableForm() {
        const FORM = '#form_notify_not_available_product';
        const EMAIL = '#email_notify';
        const PHONE = '#celular_notify';

        if (document.body.dataset.notifyMaskBound) return;
        document.body.dataset.notifyMaskBound = '1';

        const emailPattern = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;

        const validDDDs = [
            11, 12, 13, 14, 15, 16, 17, 18, 19,
            21, 22, 24, 27, 28,
            31, 32, 33, 34, 35, 37, 38,
            41, 42, 43, 44, 45, 46, 47, 48, 49,
            51, 53, 54, 55,
            61, 62, 63, 64, 65, 66, 67, 68, 69,
            71, 73, 74, 75, 77, 79,
            81, 82, 83, 84, 85, 86, 87, 88, 89,
            91, 92, 93, 94, 95, 96, 97, 98, 99
        ];

        // o cliente digita/cola do jeito que quiser: 16999999999, 16 99999-9999,
        // +55 (16) 99999-9999... aqui sobra só o DDD + número
        const phoneDigits = (value) => {
            let digits = (value || '').replace(/\D/g, '');
            if (digits.length > 11 && digits.startsWith('55')) {
                digits = digits.slice(2);
            }
            return digits.slice(0, 11);
        };

        const phoneMask = (value) => {
            const digits = phoneDigits(value);
            if (!digits.length) return '';
            if (digits.length <= 2) return `(${digits}`;
            if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
            if (digits.length <= 10) return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
            return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
        };

        const phoneError = (digits) => {
            if (!digits.length) return '';
            if (digits.length < 11) return 'Digite o DDD e os 9 dígitos do celular. Ex: (16) 99999-9999';
            if (!validDDDs.includes(Number(digits.slice(0, 2)))) return 'DDD inválido. Confira os 2 primeiros dígitos.';
            if (digits[2] !== '9') return 'Celular inválido: o número deve começar com 9 depois do DDD.';
            if (/^(\d)\1+$/.test(digits.slice(2))) return 'Digite um número de celular válido.';
            return '';
        };

        // campo vazio fica a cargo do required, para não duplicar a mensagem do navegador
        const validateEmail = (input) => {
            const value = input.value.trim();
            input.setCustomValidity(!value || emailPattern.test(value) ? '' : 'Digite um e-mail válido. Ex: nome@email.com');
        };

        const validatePhone = (input) => {
            input.setCustomValidity(phoneError(phoneDigits(input.value)));
        };

        const applyPhoneMask = (input) => {
            const masked = phoneMask(input.value);
            if (input.value !== masked) input.value = masked;
            validatePhone(input);
        };

        // só reage a campos que estejam realmente dentro do formulário de aviso
        const fieldIn = (event, selector) => {
            const target = event.target;
            if (!(target instanceof Element) || !target.matches(selector)) return null;
            return target.closest(FORM) ? target : null;
        };

        // trava letras e símbolos; separadores passam e são absorvidos pela
        // máscara, para quem digita "(16) 99999-9999" ou "16 99999 9999" na mão
        const allowedChar = /[\d()\-+.\s]/;

        document.addEventListener('beforeinput', (e) => {
            if (!fieldIn(e, PHONE)) return;
            const typing = e.inputType === 'insertText' || e.inputType === 'insertCompositionText';
            if (typing && e.data && !allowedChar.test(e.data)) {
                e.preventDefault();
            }
        });

        document.addEventListener('keydown', (e) => {
            if (!fieldIn(e, PHONE)) return;
            if (e.key === 'Enter' || e.ctrlKey || e.metaKey || e.altKey) return;
            if (e.key.length === 1 && !allowedChar.test(e.key)) {
                e.preventDefault();
            }
        });

        // input, change e focusout borbulham, então a delegação alcança os três
        ['input', 'change', 'focusout'].forEach(eventName => {
            document.addEventListener(eventName, (e) => {
                const phone = fieldIn(e, PHONE);
                if (phone) {
                    phone.classList.remove('is-invalid');
                    applyPhoneMask(phone);
                    return;
                }
                const email = fieldIn(e, EMAIL);
                if (email) {
                    email.classList.remove('is-invalid');
                    validateEmail(email);
                }
            });
        });

        // revalida antes do envio para cobrir preenchimento automático do navegador
        document.addEventListener('click', (e) => {
            const target = e.target;
            if (!(target instanceof Element) || target.type !== 'submit') return;
            const form = target.closest(FORM);
            if (!form) return;

            const email = form.querySelector(EMAIL);
            const phone = form.querySelector(PHONE);
            if (email) validateEmail(email);
            if (phone) applyPhoneMask(phone);
        }, true);

        // invalid não borbulha, por isso a fase de captura
        document.addEventListener('invalid', (e) => {
            const target = e.target;
            if (target instanceof Element && target.closest(FORM)) {
                target.classList.add('is-invalid');
            }
        }, true);
    },
    resizeThumbs() {
        const contentThumbs = document.querySelector('#product-photo');
        const imgThumb = document.querySelector('#product-photo img');
        if(contentThumbs && imgThumb) {
    let heightImg = imgThumb.getBoundingClientRect().height;
    contentThumbs.style.minHeight = heightImg + 'px';
}
        },
clickThumbs() {
    let photoArea = document.querySelector('.product-detail__header--photoArea');
    let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

    if (photoThumbs && photoArea) {
        if (photoArea.classList.contains('gallery-left') || photoArea.classList.contains('gallery-right') || photoArea.classList.contains('gallery-bottom')) {

            let photoListItem = document.querySelectorAll('#photo-list li');
            let singlePhotoItem = document.querySelectorAll('#product-photo img');

            if (photoListItem.length && singlePhotoItem.length) {
                photoListItem[0].classList.add('active');
                singlePhotoItem[0].classList.add('active');

                function activeTab(index) {
                    singlePhotoItem.forEach((content) => {
                        content.classList.remove('active');
                    });
                    singlePhotoItem[index].classList.add('active');
                }

                photoListItem.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', () => {
                        activeTab(index);
                    });
                });
            }
        }
    }

    if (photoThumbs && photoArea) {
        if (photoThumbs.classList.contains('gallery-left') || photoThumbs.classList.contains('gallery-right')) {
            $('#photo-list').slick({
                infinite: false,
                slidesToShow: 5,
                vertical: true,
                slidesToScroll: 1
            });
        }
    }
},
updateImageThumb(src) {
    this.imgSrc = src;
},

setThumbHeight() {
    return document.querySelector('.product-detail__header--photoArea-thumbs').style.height = document.querySelector('#photo-list li.visible').clientHeight * this.slidesToShow + 'px;';
},

handleESC(event) {
    if (event.key === 'Escape')
        this.showOpened = false
},

checkBuyView() {
    const buyButton = document.getElementById("buy-button");
    const rect = buyButton.getBoundingClientRect();

    if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
        const otherElement = document.querySelector(".product-detail__fixed--buy");
        if (otherElement) {
            otherElement.classList.remove("active");
        }
    } else {
        const otherElement = document.querySelector(".product-detail__fixed--buy");
        if (otherElement) {
            otherElement.classList.add("active");
        }
    }
},

zoom(event) {
    const container = document.getElementById('zoom-container');
    const image = document.getElementById('zoom-image');

    const containerRect = container.getBoundingClientRect();
    const mouseX = event.clientX - containerRect.left;
    const mouseY = event.clientY - containerRect.top;

    if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
        const zoomLevel = 1.2;
        const newWidth = container.offsetWidth * zoomLevel;
        const newHeight = container.offsetHeight * zoomLevel;

        const offsetX = -(mouseX * (zoomLevel - 1));
        const offsetY = -(mouseY * (zoomLevel - 1));

        image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

        if (offsetX > 0) {
            image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
        }
        if (offsetY > 0) {
            image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
        }
        if (offsetX < -(newWidth - container.offsetWidth)) {
            image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
        }
        if (offsetY < -(newHeight - container.offsetHeight)) {
            image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
        }
    }
},

resetZoom() {
    const image = document.getElementById('zoom-image');
    image.style.transform = 'translate(0, 0) scale(1)';
},

clickThumbsMosaic() {
    const thumbs = document.querySelector('.product-detail__header--photoArea-thumbs-default');
    const photos = document.querySelector('#product-photo ul');
    if (thumbs) {
        thumbs.addEventListener('click', function (event) {
            if (event.target.classList.contains('product-detail__header--photoArea-mobile-img')) {
                const eventPhoto = event.target.closest('.sp-wrap');
                const targetPhoto = photos.querySelector(`#${eventPhoto.id}`);
                if (targetPhoto) {
                    const offset = (window.innerHeight / 2) - (targetPhoto.offsetHeight / 2);
                    const elementPosition = targetPhoto.getBoundingClientRect().top + window.scrollY;

                    window.scrollTo({
                        top: elementPosition - offset,
                        behavior: 'smooth'
                    });
                }
            }
        })
    }
},

moveToBuy() {
    var productSize = document.querySelector(".product-detail__header--infoArea-variation");
    if (productSize) {
        productSize.scrollIntoView({ behavior: "smooth" });
    }
}
    },
mounted() {
    this.initNotifyNotAvailableForm();
    this.clickThumbs();
    this.clickThumbsMosaic();

    const btnBuyAddToCart = document.querySelector('.product-detail__header--infoArea-buy-section-button .btn__product_detail__add_to_cart');
    if (btnBuyAddToCart && !btnBuyAddToCart.classList.contains('to-checkout')) {
        btnBuyAddToCart.addEventListener('click', (e) => {
            e.preventDefault();
        });
    }

    const photoList = document.getElementById("photo-list");
    if (photoList) {
        const firstLi = photoList.querySelector("li");
        if (firstLi) {
            const imgElement = firstLi.querySelector("img");

            if (imgElement) {
                this.imgSrc = imgElement.getAttribute("src");
                this.imgTitle = imgElement.getAttribute("title");
            }
        }
    }

    const userLetterElement = document.getElementById('user_letter');
    if (userLetterElement) {
        const userLetter = userLetterElement.innerText.trim();
        if (userLetter.length > 0) {
            userLetterElement.innerText = userLetter[0];
        }
    }

    document.addEventListener('keydown', this.handleESC, { passive: true });
    window.addEventListener("scroll", this.checkBuyView, { passive: true });
    window.addEventListener("load", this.checkBuyView, { passive: true });
},
beforeDestroy() {
    document.removeEventListener('keydown', this.handleESC);
},
watch: {
    showOpened(newValue) {
        if (newValue) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.removeProperty('overflow');
        }
    },
}
})

$(document).ready(function () {



    waitForElementToExist('#js_shipping_calculation_table .product-detail__table__column').then(element => {
        const itemFreight = document.querySelectorAll('#js_shipping_calculation_table_body tr');
        if (itemFreight.length) {
            itemFreight.forEach(item => {
                let resumeValue = item.querySelector('.product-detail__table__column .value-line-through + span');
                resumeValue.style.color = '#30ad23';
                if (resumeValue.textContent == 'R$ 0.00') {
                    resumeValue.textContent = 'Grátis';
                }
            });
        }
    });

    waitForElementToExist('#js_buy_together_api_layout_1_groups').then(element => {
        // Controle de seleção dos tamanhos nos grupos (2 a 3 Uls possíveis)
        const ADD_CART_BTN_SELECTOR = '#js_buy_together_api_add_cart';
        const GROUP_IDS = ['#js_buy_together_api_group_0', '#js_buy_together_api_group_1', '#js_buy_together_api_group_2'];

        const getGroups = () => GROUP_IDS
            .map(sel => document.querySelector(sel))
            .filter(Boolean);

        const isGroupSelected = (group) => {
            if (!group) return false;
            const options = group.querySelector('.product-item__options');
            if (!options) return false;

            // Seleção via select
            const select = options.querySelector('select');
            if (select) {
                const val = select.value;
                return val !== '' && val !== undefined && val !== null && val !== '0';
            }

            // Seleção via inputs (ex: radio)
            const radios = options.querySelectorAll('input[type="radio"]');
            if (radios.length) {
                return Array.from(radios).some(r => r.checked);
            }

            const checkboxes = options.querySelectorAll('input[type="checkbox"]');
            if (checkboxes.length) {
                return Array.from(checkboxes).some(c => c.checked);
            }

            // Outros inputs (fallback): considera preenchido se houver value não vazio
            const inputs = options.querySelectorAll('input');
            if (inputs.length) {
                return Array.from(inputs).some(i => (i.type !== 'radio' && i.type !== 'checkbox') && i.value && String(i.value).trim() !== '');
            }

            return false;
        };

        const updateUI = () => {
            const groups = getGroups();
            const addCartBtn = document.querySelector(ADD_CART_BTN_SELECTOR);
            if (!groups.length || !addCartBtn) return;

            // Atualiza classe please-select por grupo
            groups.forEach(group => {
                const selected = isGroupSelected(group);
                group.classList.toggle('please-select', !selected);
            });

            // Regra: liberar compra quando TODOS os grupos presentes tiverem seleção
            const allSelected = groups.every(g => isGroupSelected(g));
            addCartBtn.classList.toggle('no-buy', !allSelected);
        };

        const bindEvents = () => {
            const container = document.querySelector('#js_buy_together_api_layout_1_groups');
            if (!container) return;

            // Delegação para mudanças em selects e inputs dentro dos grupos
            container.addEventListener('change', (e) => {
                const target = e.target;
                if (!(target instanceof Element)) return;
                if (target.closest('#js_buy_together_api_group_0, #js_buy_together_api_group_1, #js_buy_together_api_group_2')) {
                    updateUI();
                }
            }, { passive: true });

            // Alguns temas usam click para marcar radios customizados
            container.addEventListener('click', (e) => {
                const target = e.target;
                if (!(target instanceof Element)) return;
                if (target.closest('#js_buy_together_api_group_0, #js_buy_together_api_group_1, #js_buy_together_api_group_2')) {
                    // pequeno defer para permitir atualização de checked
                    setTimeout(updateUI, 0);
                }
            }, { passive: true });

            // Observa mudanças dinâmicas (ex: render async dos grupos)
            const observer = new MutationObserver(() => {
                updateUI();
            });
            observer.observe(container, { childList: true, subtree: true });
        };

        bindEvents();
        // Inicializa estado
        updateUI();
    });

    let listBuyTogether = document.getElementById('js_buy_together_api_layout_1_groups'),
        options = {
            childList: true
        }
    if (listBuyTogether) {
        observer = new MutationObserver(Callback);
        observer.observe(listBuyTogether, options);

        function Callback() {
            const products = document.querySelectorAll('#js_buy_together_api_layout_1_groups ul');
            if (products.length) {
                products.forEach(product => {
                    const options = product.querySelector('.product-item__options');
                    if (options) {
                        options.addEventListener('click', () => {
                            const radioVariation = options.querySelector('.product-radio-variation');
                            if (radioVariation) {
                                radioVariation.classList.toggle('active');
                            }
                            product.classList.toggle('active');
                        });

                        if (window.matchMedia("(max-width: 991px)").matches) {
                            const detailList = product.querySelector('.product-item__content--container');
                            if (detailList) {
                                detailList.appendChild(options);
                            }
                        }
                    }
                });
            }
        }
    }

    if ($('.carrousel-photos').length) {
        let $carousel = $('.carrousel-photos');
        let $counter = $('.count-images');

        // Inicializa o slick
        $carousel.on('init', function (event, slick) {
            $counter.text(`1/${slick.slideCount}`);
        });

        $carousel.on('afterChange', function (event, slick, currentSlide) {
            $counter.text(`${currentSlide + 1}/${slick.slideCount}`);
        });

        $carousel.slick({
            swipeToSlide: true,
            touchThreshold: 100,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: $('.icon-arrow-left'),
            nextArrow: $('.icon-arrow-right'),
            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 100,
            vertical: false,
        });
    }

    $('.product-rating__review-list').slick({
        dots: false,
        arrows: true,
        infinite: false,
        autoplay: true,
        adaptiveHeight: true,
        speed: 1000,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    if (document.querySelector(".carousel-kit")) {
        var splide = new Splide('.carousel-kit', {
            type: "slide",
            autoplay: false,
            rewind: false,
            arrows: false,
            speed: 800,
            perPage: 1,
            perMove: 1,
            drag: false,
            pauseOnFocus: false,
            height: "auto",
            pagination: false,
            breakpoints: {
                768: {
                    drag: false,
                },
            },
        });

        splide.on('mounted', function () {
            var totalSlides = splide.length;
            var nextButton = document.querySelector('.carousel-kit-next');
            nextButton.setAttribute('data-end', totalSlides - 1);

            var addToCartButton = document.querySelector('.js-btn__product_detail__add_to_cart');
            addToCartButton.classList.add('no-buy');

            var countDisplay = document.querySelector('.carousel-count');
            countDisplay.textContent = '1/' + totalSlides;
        });

        splide.mount();

        var nextButton = document.querySelector('.carousel-kit-next');
        var prevButton = document.querySelector('.carousel-kit-prev');
        var message = document.querySelector('.carousel-message');
        var addToCartButton = document.querySelector('.js-btn__product_detail__add_to_cart');
        var countDisplay = document.querySelector('.carousel-count');

        nextButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end) {
                var activeSlide = document.querySelector('.splide__slide.is-active');
                var radioChecked = activeSlide.querySelector('.product-radio-variation input[type="radio"]:checked');
                var noVariations = activeSlide.querySelector('.js_product_item_kit').getAttribute('data-no-variations');

                if (radioChecked || noVariations) {
                    splide.go('>');
                    actual = Math.min(actual + 1, end);
                    nextButton.setAttribute('data-actual', actual);
                    message.classList.remove('show');
                    if (actual === end) {
                        addToCartButton.classList.remove('no-buy');
                        nextButton.classList.add('no-click');
                    }
                } else {
                    message.classList.add('show');
                }
            }
        });

        prevButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end && actual > 0) {
                if (actual === end) {
                    nextButton.classList.remove('no-click');
                }
                splide.go('<');
                actual = Math.max(actual - 1, 0);
                nextButton.setAttribute('data-actual', actual);
            }
        });

        splide.on('move', function () {
            var i = splide.index + 1;
            countDisplay.textContent = i + '/' + splide.length;
        });
    }

    const brinde = document.querySelector('#js_buy_together_api_layout_2');

    if (brinde) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                    }
                });
            });
        });

        observer.observe(brinde, {
            childList: true,
            subtree: true
        });

    }

    const allSizesLabel = document.querySelectorAll('label[for^="product_item_variation__product_detail__');
    if (allSizesLabel) {
        allSizesLabel.forEach(label => {
            label.addEventListener('click', () => {
                const inputId = label.getAttribute('for');
                if (inputId) {
                    const container = document.querySelector('.product-detail__fixed--buy');
                    if (container) {
                        const inputsInContainer = container.querySelectorAll('input.clicou');
                        inputsInContainer.forEach(input => {
                            input.classList.remove('clicou');
                        });
                    }

                    const allInputs = document.querySelectorAll(`input[id^="${inputId}"]`);

                    if (allInputs) {
                        allInputs.forEach(input => {
                            input.classList.add('clicou');
                        })
                    }

                }
            });
        })
    }

    const galleryCarrousel = document.querySelector('.gallery-carrousel');
    if (galleryCarrousel) {
        $('#product-photo').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 1000,
            vertical: false,
        });
    }

    $('.product-detail__header--photoArea-mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
        responsive: [
            {
                breakpoint: 991,
                settings: "unslick"
            },
        ]
    });

    waitForElementToExist('.product__colors.attribute').then(element => {
        $('.product__colors.attribute').slick({
            arrows: true,
            dots: false,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 6,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 12,
                    }
                },
            ]
        });
    });

    $('#product-detail-related-carrousel').slick({
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    dots: false,
                    slidesToShow: 3,
                }
            }
        ]
    });

    $('#product-detail-related-carrousel').on('afterChange', function (event, slick, currentSlide, nextSlide) {
        Blazy({
            selector: '.lazy-img',
            successClass: 'loaded-img',
            success: function (element) {
                setTimeout(function () {
                    var parent = element.previousSibling;
                    try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                }, 200);
            }
        });
    });

    $('#photo-fancy').fancybox();

    const headers = document.querySelectorAll('.product-detail__header--infoArea-description-tab h2');
    const descriptions = document.querySelectorAll('.description');

    headers.forEach(header => {
        header.addEventListener('click', () => {
            headers.forEach(h => h.classList.remove('active'));
            descriptions.forEach(description => description.classList.remove('active'));

            header.classList.add('active');

            const index = header.getAttribute('data-index');

            const activeDescription = document.querySelector(`.description[data-index="${index}"]`);
            activeDescription.classList.add('active');
        });
    });
})